<template>
  <div class="menu nf-flex" :class="{expended: expend}">
    <div class="fill-content container nf-flex nf-wrap" ref="container">
      <span v-for="(item, index) of menu"
            :key="index"
            class="menu-item"
            :class="{active:isActive(item)}"
      >
        <slot v-bind:value="item" v-bind:index="index">{{item}}</slot>
      </span>
    </div>
    <span class="expend" @click="expend = !expend" v-if="isEllipsis">
      <slot name="expend">全部</slot>
      <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAICAYAAADN5B7xAAAAAXNSR0IArs4c6QAAAHNJREFUKFN10LEJgDAQRuHnCM5h4RKKVoLzOYSFjeAcmcMRlF/u4BKiYHN5n+RsqD+zjc/yuKn0inebr0CGSuBxMtABGYogxqOBC8iQgzK+DbRAhgQG4AB0DX3ZY18vokVgA3pgqsQRafkkoPf5+b1x/HUv+i8Y7MtuEckAAAAASUVORK5CYII="
            alt=""
        />
    </span>
  </div>
</template>

<script>
function isEllipsis(el) {
  return el.scrollHeight > el.clientHeight
}
export default {
  name: "Menu",
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
    isActive: {
      type: Function,
      default: () => {
        return () => false
      },
    }
  },
  data() {
    return {
      expend: false,
      isEllipsis: false
    }
  },
  computed: {
  },
  mounted() {
    this.refresh()
  },
  methods: {
    refresh() {
      const temp = isEllipsis(this.$refs.container)
      if(temp !== this.isEllipsis) {
        this.isEllipsis = temp
      }
    }
  }
}
</script>

<style lang="less" scoped>
.menu {
  font-size: 16px;

  font-weight: 400;
  color: #333333;
  line-height: 20px;
  .wrapper();
  > .container {
    height: 48px;
    overflow: hidden;
    .menu-item {
      padding: 14px 0px;
      margin: 0px 20px;
      word-break: keep-all;
      cursor: pointer;
      -moz-font-smoothing: auto;
      &.active{
      
        font-weight: 500;

        border-bottom: 2px solid #247dff;
        padding-bottom: 12px;
      }
      &:hover {
      
        font-weight: 500;
      }
    }
  }
  > .expend {
    flex: 0 0 auto;
    align-self: start;
    padding: 14px 0px;
    margin: 0px 20px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;

    &:hover {
    
      font-weight: 500;
    }
    > img {
      display: inline-block;
      vertical-align: middle;
      margin-left: 5px;
      transition: transform 100ms ease;
      transform: rotate(180deg);
    }
  }
  &.expended {
    > .container {
      height: auto;
      //overflow: visible;
    }
    > .expend > img {
      transform: rotate(0deg);
    }
  }
}
</style>
